import { TTAPI } from '@/services/TimeTrexClientAPI';
import Nanobar from 'nanobar'; // need to rely on the default export via CommonJS syntax, hence no named import.

export var ProgressBar = ( function() {

	var loading_box = null;

	var layout_content = null;

	var left_offset = 0;

	var process_number = false;

	var can_close = false;

	var timer = null;

	var close_time = null;

	var circle = null;

	var doing_close = false;

	var message_id_dic = {};

	var updating_message_id = false;

	var current_process_id = false;

	var _progress_bar_api = false;

	var get_progress_timer = null;

	var first_start_get_progress_timer = false;

	var start_progress_timer = false;

	var auto_clear_message_id_dic = {}; //for which api calls don't have return; for example all report view calls
	// Issue #3733: some out-of-band callers independently verify the same MessageID and must own the one terminal alert shown to
	// the user. Keep this request-scoped instead of using a global mode: unrelated concurrent progress operations must continue
	// displaying their own errors, and the shared progress popup must remain available for visual processing feedback.
	var suppressed_error_alert_message_id_dic = {};

	var last_iteration = null;

	var temp_message_until_close = '';

	var second_timer;

	var expected_end_time = null;

	var displayed_time_remaining = null;

	var per_second_adjustment = 0;

	var adjustment_ticks_remaining = 0;

	var current_percent_complete = 0;

	var nanoBar;

	var loading_bar_time;

	var no_progress_for_next_call = false;

	var next_check_time = 2000;

	var showOverlay = function() {
		document.getElementById( 'overlay' )?.classList.add( 'overlay' );
		Global.setUINotready();
		TTPromise.add( 'ProgressBar', 'overlay_visible' );
	};

	var closeOverlay = function() {
		//this variable is set in BaseViewController::onContextMenuClick
		if ( window.clickProcessing == true ) {
			window.clickProcessing = false;
			window.clearTimeout( window.clickProcessingHandle );
		}
		document.getElementById( 'overlay' )?.classList.remove( 'overlay' );
		Global.setUIReady();
		TTPromise.resolve( 'ProgressBar', 'overlay_visible' );
	};

	var cancelProgressBar = function() {
		if ( get_progress_timer ) {
			clearTimeout( get_progress_timer );
			get_progress_timer = null;
		}
		removeProgressBar( current_process_id );
		get_progress_timer = null;
		current_process_id = false;
		last_iteration = null;
		first_start_get_progress_timer = false;
	};

	/**
	 * Register a request with the shared progress UI.
	 *
	 * suppress_error_alert does not hide progress and does not discard the backend message. It only records that another consumer
	 * polling this exact MessageID will display the terminal error. This avoids two alerts while preserving default behavior for
	 * every existing caller that omits the fourth argument.
	 */
	var showProgressBar = function( message_id, auto_clear, instant, suppress_error_alert ) {

		TTPromise.add( 'ProgressBar', 'MASTER' );
		if ( no_progress_for_next_call ) {
			no_progress_for_next_call = false;
			return;
		}
		if ( instant ) {
			// Issue #3854: Hide only the visual indicator; keep MessageID polling,
			// MASTER resolution and the input-blocking overlay unchanged.
			if ( process_number > 0 && loading_box && window.TTPresentation?.getStatus().suppressProgressBar !== true ) {
				loading_box.style.display = 'block';
			}
		} else {
			if ( !timer ) {
				// Display progress bar after 1 sec
				timer = setTimeout( function() {
					// Issue #3854: Hide only the visual indicator; keep MessageID polling,
					// MASTER resolution and the input-blocking overlay unchanged.
					if ( process_number > 0 && loading_box && window.TTPresentation?.getStatus().suppressProgressBar !== true ) {
						loading_box.style.display = 'block';
					}
				}, 1000 );
			}
		}

		if ( message_id ) {
			// All per-request behavior is keyed by MessageID so overlapping API work cannot inherit another request's lifecycle flags.
			message_id_dic[message_id] = true;

			if ( auto_clear ) {
				auto_clear_message_id_dic[message_id] = true;
			}
			if ( suppress_error_alert === true ) {
				// Keep the flag request-scoped until cleanup; getProgressBarProcess() snapshots it before each async read so mid-read dismissal cannot change alert ownership.
				suppressed_error_alert_message_id_dic[message_id] = true;
			}
		}

		if ( message_id && start_progress_timer === false ) {
			//Debug.Text( 'Next Check Time: ' + next_check_time, 'ProgressBarManager.js', 'ProgressBarManager', 'showProgressBar', 10 );
			start_progress_timer = setTimeout( function() {
				getProgressBarProcess();
			}, next_check_time );
			// Remove first_start_get_progress_timer as it's no longer needed
		}

		if ( process_number > 0 ) { // has multi call or the last call is not removed yet
			process_number = process_number + 1;
			return;
		}

		process_number = 1;

		Global.addCss( 'global/widgets/loading_bar/LoadingBox.css' );

		clearTimeout( close_time );
		close_time = null;
		var message_label;

		if ( !loading_box ) {
			var loadingBoxWidget = `
				<div class="popup-loading">
					<div class="processing"></div>
					<span class="close-icon">x</span>
					<progress class="progress-bar" max="100" value="10">
					</progress>
					<div class="complete-info">100 / 5000 - 15% Complete</div>
					<div class="time-remaining">11:11</div>
				</div>
			`;

			var template = document.createElement( 'template' );
			template.innerHTML = loadingBoxWidget.trim();

			var loadngBox = template.content.firstElementChild;
			loadngBox.id = 'progressBar';

			var close_icon = loadngBox.querySelector( '.close-icon' );

			close_icon.addEventListener( 'click', function() {
				cancelProgressBar();
			} );
			// css only spinner - and yes, it does unfortunately need all those divs. They are for each of the spokes of the circle.
			var circle_template = document.createElement( 'template' );
			circle_template.innerHTML = '<div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>';
			circle = circle_template.content.firstElementChild;

			document.body.appendChild( loadngBox );
			loading_box = document.getElementById( 'progressBar' );
			message_label = loading_box.querySelector( '.processing' );

			if ( circle ) {
				message_label.after( circle );
			}

			loading_box.style.display = 'none';
			layout_content = document.querySelector( '.layout-content' );

		} else {
			message_label = loading_box.querySelector( '.processing' );

			//If the user is logged in offset the progress bar to be centered inside the content portion of page taking into account the main left menu.
			//However if a wizard is displayed, the progress bar should be centered within the wizard overlay (entire page).
			if ( TTCurrentSession.getLoginUser() && layout_content && left_offset !== layout_content.offsetLeft && !document.querySelector( '.wizard-overlay' ) ) {
				// TODO: The fix above to add '&&layout_content' still does not solve why the above line is referencing layout_content when its not defined in the same scope/block
				left_offset = ( layout_content.offsetLeft / 2 );
				loading_box.style.left = 'calc( 50% + ' + left_offset + 'px )';
			} else {
				loading_box.style.left = '50%';
			}

			if ( circle ) {
				message_label.after( circle );
			}

		}

		resetToDefault();
	};

	var resetToDefault = function() {

		if ( temp_message_until_close ) {
			//Default process message, change this when update progress bar.
			loading_box.querySelector( '.processing' ).textContent = temp_message_until_close;
		} else {
			//Default process message, change this when update progress bar.
			// TTi18n now owns dictionary state directly, so this default label no
			// longer needs to probe the removed browser translation plugin first.
			loading_box.querySelector( '.processing' ).textContent = TTi18n.getText( 'Processing...' );
		}

		var complete_info = loading_box.querySelector( '.complete-info' );
		var progress_bar = loading_box.querySelector( '.progress-bar' );
		var time_remaining = loading_box.querySelector( '.time-remaining' );

		complete_info.style.display = 'none';
		progress_bar.style.display = 'none';
		time_remaining.style.display = 'none';

		complete_info.textContent = 0 + ' / ' + 0 + ' ' + 0 + '%';
		progress_bar.value = 0;

		last_iteration = null;
		expected_end_time = ( Date.now() + 0 ); // Default to 0 seconds in the future
		displayed_time_remaining = 0;          // Start with 0 seconds
		per_second_adjustment = 0;
		adjustment_ticks_remaining = 0;
		current_percent_complete = 0; // Reset percent complete
	};

	var changeProgressBarMessage = function( val ) {
		temp_message_until_close = val;
		if ( loading_box ) {
			loading_box.querySelector( '.processing' ).textContent = val;
		}

	};

	var updateProgressbar = function( data ) {

		if ( !loading_box ) {
			return;
		}

		loading_box.querySelector( '.processing' ).textContent = data.message;

		current_percent_complete = ( data.current_iteration / data.total_iterations ); //Store globally so other functions can read it.

		var complete_info = loading_box.querySelector( '.complete-info' );
		var progress_bar = loading_box.querySelector( '.progress-bar' );
		var time_remaining = loading_box.querySelector( '.time-remaining' );

		complete_info.style.display = 'block';
		progress_bar.style.display = 'block';
		time_remaining.style.display = 'block';

		complete_info.textContent = data.current_iteration + ' / ' + data.total_iterations + ' ( ' + ( current_percent_complete * 100 ).toFixed( 0 ) + '% )';
		progress_bar.value = ( current_percent_complete * 100 );

		if ( !last_iteration || data.current_iteration == 0 ) {
			time_remaining.textContent = TTi18n.getText( 'Patience is a Virtue...' );
		} else {
			var new_expected_end_time;
			if ( data.remaining_time > 0 ) {
				new_expected_end_time = ( Date.now() + ( data.remaining_time * 1000 ) );
			} else {
				// If remaining time is zero or negative, set expected_end_time to now
				new_expected_end_time = Date.now();
			}

			if ( expected_end_time === null ) {
				expected_end_time = new_expected_end_time;
				displayed_time_remaining = ( ( expected_end_time - Date.now() ) / 1000 );
			} else {
				// Adjust expected_end_time smoothly towards new_expected_end_time
				var adjustment_duration_ms = Math.max( 2000, next_check_time );
				var adjustment_ticks = Math.ceil( adjustment_duration_ms / 1000 );
				var time_difference_ms = ( new_expected_end_time - expected_end_time );
				per_second_adjustment = ( ( time_difference_ms / adjustment_ticks ) / 1000 ); // Convert to seconds
				adjustment_ticks_remaining = adjustment_ticks;
			}
		}

		secondDown();

		last_iteration = data.current_iteration;
	};

	var noProgressForNextCall = function() {
		no_progress_for_next_call = true;
	};

	var getStatus = function() {
		var progress_element = loading_box ? loading_box : ( typeof document != 'undefined' ? document.getElementById( 'progressBar' ) : null );
		var progress_style = progress_element ? window.getComputedStyle( progress_element ) : null;
		var progress_rect = progress_element ? progress_element.getBoundingClientRect() : null;
		var visible = !!( progress_element && progress_style && progress_style.display !== 'none' && progress_style.visibility !== 'hidden' && progress_rect && progress_rect.width > 0 && progress_rect.height > 0 );

		return {
			processNumber: Number( process_number ) || 0,
			timerActive: timer !== null,
			closeTimerActive: close_time !== null,
			startProgressTimerActive: start_progress_timer !== false && start_progress_timer !== null,
			getProgressTimerActive: get_progress_timer !== false && get_progress_timer !== null,
			currentProcessId: current_process_id || null,
			messageCount: Object.keys( message_id_dic || {} ).length,
			autoClearMessageCount: Object.keys( auto_clear_message_id_dic || {} ).length,
			visible: visible,
			display: progress_style ? progress_style.display : null,
			visibility: progress_style ? progress_style.visibility : null,
		};
	};

	var secondDown = function() {
		if ( !second_timer ) {
			var time_remaining = loading_box.querySelector( '.time-remaining' );
			second_timer = setInterval( function() {
				if ( expected_end_time !== null ) {
					displayed_time_remaining = ( ( expected_end_time - Date.now() ) / 1000 );

					if ( adjustment_ticks_remaining > 0 ) {
						expected_end_time += ( per_second_adjustment * 1000 ); // Convert to milliseconds
						adjustment_ticks_remaining--;
					}

					if ( displayed_time_remaining <= 0 ) {
						displayed_time_remaining = 0;
						if ( current_percent_complete >= 0.80 ) { //80%
							time_remaining.textContent = TTi18n.getText( 'Almost Done...' );
						} else {
							time_remaining.textContent = TTi18n.getText( 'Patience is a Virtue...' );
						}
					} else {
						time_remaining.textContent = Global.getTimeUnit( displayed_time_remaining, 99 );
					}
				} else {
					time_remaining.textContent = TTi18n.getText( 'Patience is a Virtue...' );
				}
			}, 1000 );
		}
	};

	var getProgressBarProcess = function() {
		if ( !TTCurrentSession.getLoginData() ) {
			return;
		}

		if ( !current_process_id ) {
			for ( var key in message_id_dic ) {
				current_process_id = key;

				delete message_id_dic[key];
				break;
			}
		}

		// Progress ids come from message_id_dic object keys, so valid ids should be
		// strings. The previous jQuery helper checked the literal variable name,
		// which let any truthy non-string value reach the API call.
		if ( current_process_id && typeof current_process_id === 'string' ) {
			// Issue #3733: snapshot alert ownership before the asynchronous read. The user can dismiss the progress popup while the
			// request is in flight, which clears live dictionaries; consulting them inside onResult() could then incorrectly display
			// a second shared alert alongside the wizard-owned terminal alert.
			const suppress_error_alert = suppressed_error_alert_message_id_dic[current_process_id] === true;
			TTAPI.APIProgressBar.getProgressBar( current_process_id, {
				onResult: function( result ) {
					var result_data = result.getResult();

					// next_check_time must be class scoped to be used in showProgressBar()
					if ( result_data['next_check_time'] ) {
						next_check_time = ( parseInt( result_data['next_check_time'] ) * 1000 );
					} else {
						next_check_time = 2000;
					}
					Debug.Text( 'Time Remaining: '+ result_data['remaining_time'] + ' Next Check Time: ' + next_check_time, 'ProgressBarManager.js', 'ProgressBarManager', 'getProgressBarProcess', 10 );

					// Retained terminal states are results, not percentages. Stop the shared progress lifecycle immediately, but leave
					// caller-owned result handling to the independent poller that is reading this same MessageID (Issue #3733).
					if ( result_data.hasOwnProperty( 'status_id' ) && result_data.status_id === 9999 ) {
						stopProgress();
						// Default callers still receive the established error alert. Suppression is narrowly opt-in and does not erase the message.
						if ( suppress_error_alert === false ) {
							TAlertManager.showAlert( result_data.message );
						}
					} else if ( result_data.hasOwnProperty( 'status_id' ) && result_data.status_id === 1000 ) {
						// Affirmative completion needs no shared alert; the workflow that requested verification owns its success UX.
						stopProgress();
					} else {
						if ( result_data === true ||
							( Array.isArray( result_data ) && result_data.length === 0 ) || !result_data.total_iterations ||
							typeof result_data.total_iterations !== 'number' ) {
							stopProgress();
							return;
						} else {
							updateProgressbar( result_data );

							// Schedule the next check based on next_check_time
							if ( get_progress_timer ) {
								clearTimeout( get_progress_timer );
							}
							get_progress_timer = setTimeout( function() {
								getProgressBarProcess();
							}, next_check_time );
						}
					}

				}
			} );
		}

	};

	function stopProgress() {
		if ( start_progress_timer ) {
			clearTimeout( start_progress_timer );
			start_progress_timer = false;
		}
		if ( get_progress_timer ) {
			clearTimeout( get_progress_timer );
			get_progress_timer = false;
		}

		if ( auto_clear_message_id_dic[current_process_id] ) {
			removeProgressBar( current_process_id );
		}

		get_progress_timer = false;
		current_process_id = false;
		last_iteration = null;
		first_start_get_progress_timer = false;
	}

	var removeProgressBar = function( message_id ) {
		if ( message_id ) {
			// Remove every piece of request-scoped policy together so a reused/stale MessageID cannot inherit alert suppression.
			delete message_id_dic[message_id];
			delete auto_clear_message_id_dic[message_id];
			delete suppressed_error_alert_message_id_dic[message_id];

			if ( current_process_id === message_id ) {
				current_process_id = false;
			}

		}

		if ( process_number > 0 ) {
			process_number = process_number - 1;

			if ( process_number === 0 ) {
				removeProgressBar();
			}

		} else {
			if ( loading_box ) {
				doing_close = true;
				clearTimeout( close_time );

				//shorten timeout in unit test mode.
				var close_time_timeout = Global.UNIT_TEST_MODE ? 10 : 500;
				close_time = setTimeout( function() {
					close_time = null;
					closeOverlay();

					if ( second_timer ) {
						clearInterval( second_timer );
						second_timer = null;
					}

					timer = null;
					temp_message_until_close = '';
					if ( loading_box ) {
						loading_box.style.display = 'none';

						if ( get_progress_timer ) {
							clearTimeout( get_progress_timer );
							get_progress_timer = false;
						}

						if ( start_progress_timer ) {
							clearTimeout( start_progress_timer );
							start_progress_timer = false;
						}

					}

					TTPromise.resolve( 'ProgressBar', 'MASTER' );
				}, close_time_timeout );
			}
		}

	};

	var showNanobar = function() {
		if ( !nanoBar ) {
			var options = {
				bg: 'red',
				id: 'nano-bar'
			};
			nanoBar = new Nanobar( options );
		}
		var percentage = 0;
		loading_bar_time && clearInterval( loading_bar_time );
		loading_bar_time = setInterval( function() {
			if ( percentage < 80 ) {
				percentage = percentage + 20;
				nanoBar.go( percentage );
			} else if ( percentage === 80 ) {
				percentage = percentage + 10;
				nanoBar.go( percentage );
			}

		}, 1000 );
	};

	var removeNanobar = function() {
		loading_bar_time && clearInterval( loading_bar_time );
		nanoBar && nanoBar.go( 100 );
		closeOverlay();
	};

	return {
		showProgressBar: showProgressBar,
		removeProgressBar: removeProgressBar,
		showOverlay: showOverlay,
		closeOverlay: closeOverlay,
		getStatus: getStatus,
		message_id_dic: message_id_dic,
		changeProgressBarMessage: changeProgressBarMessage,
		cancelProgressBar: cancelProgressBar,
		showNanobar: showNanobar,
		removeNanobar: removeNanobar,
		noProgressForNextCall: noProgressForNextCall
	};

} )();
